import React from "react";

const Derivative = (props) => (
    <div className={props.className}>
        <input {...props.derivativeDescription}
            type="text"
            placeholder={props.placeholder}
            className="x-description idea-attribute__input"
            style={{width: 145, borderRadius: "4px 0 0 4px"}} />
    </div>
);
Derivative.propTypes = {
    placeholder: React.PropTypes.string
};

export default Derivative



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/Derivative.js
 **/